import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { formatNumber } from '../../../Utils/Money';

class ClosuresOfCashReceiptsPDFAccountant {

    exportPDFAccountant = async (data, starterDate, finalDate, admissionsWithoutRecipts) => {

        pdfMake.fonts = {
            OpenSans: {
                normal: 'OpenSans-Regular.ttf',
                bold: 'OpenSans-Bold.ttf',
                italics: 'OpenSans-Italic.ttf',
                bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
            },
            Merriweather: {
                normal: 'Merriweather-Regular.ttf',
                bold: 'Merriweather-Bold.ttf',
                italics: 'Merriweather-Italic.ttf',
                bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
            },
            Roboto: {
                normal: 'Roboto-Regular.ttf',
                bold: 'Roboto-Bold.ttf',
                italics: 'Roboto-Italic.ttf',
                bolditalics: 'Roboto-BoldItalic.ttf'
            },
            CantoraOne: {
                bold: 'CantoraOne-Regular.ttf'
            }
        };

        const clinica = JSON.parse(sessionStorage.getItem('clinica'));
        const currentUser = JSON.parse(sessionStorage.getItem('usuario'));
        console.log("DATARECEIPTSPDF", data, starterDate, finalDate, admissionsWithoutRecipts);

        const servicesToShow = (services) => {
            let admissionServices = ''
            if (!!services) {
                if (!!services.length) {
                    admissionServices = services.reduce((acc, curr) => {
                        let namesServices = '';
                        namesServices = acc !== "" ? acc + '\n' + curr.nombre : curr.nombre
                        return namesServices
                    }, '');
                    return admissionServices;
                }
            } else {
                return admissionServices;
            }
        }

        const consolidados = (data) => {
            let bodyConsolidado = [];
            bodyConsolidado.push([
                { text: 'Recibos de Caja Consolidados', style: 'tableheader' },
                '',
            ]);
            bodyConsolidado.push(
                [
                    { text: 'Nombre del Cliente', bold: true, style: 'textStyle' },
                    { text: "Total del Cliente", bold: true, style: 'textStyle' },
                ]
            );

            for (var i = 0; i < data.length; i++) {
                let total = parseInt(data[i].total)
                bodyConsolidado.push(
                    [
                        { text: data[i].cliente, bold: true, style: 'textStyle' },
                        { text: '$' + formatNumber(total), bold: true, style: 'textStyle' },
                    ]
                );
            }
            return bodyConsolidado;
        }

        let tableAdmissionsWithoutReceipt = [];
        tableAdmissionsWithoutReceipt.push(
            [
                { text: "Admisión", bold: true, style: 'textStyle' },
                { text: "Fecha", bold: true, style: 'textStyle' },
                { text: "servicio", bold: true, style: 'textStyle' },
                { text: "Cliente", bold: true, style: 'textStyle' },
                { text: "Plan", bold: true, style: 'textStyle' },
            ]
        );
        let newOrderAdmissionsWReceipts = [];
        if (!!admissionsWithoutRecipts) {
            newOrderAdmissionsWReceipts = admissionsWithoutRecipts.admisionesSinRecibo.sort((a, b) => b.id_admision - a.id_admision);
        }
        try {
            for (let j = 0; j < newOrderAdmissionsWReceipts.length; j++) {
                const element = newOrderAdmissionsWReceipts[j];
                tableAdmissionsWithoutReceipt.push([
                    { text: element.id_admision, style: "textStyle" },
                    { text: moment(element.fecha_admision).format("YYYY-MM-DD") + "-" + element.hora, style: "textStyle" },
                    { text: servicesToShow(element.servicio.servicios), style: "textStyle" },
                    { text: element.nombre_tercero, style: "textStyle" },
                    { text: element.nombre_plan, style: "textStyle" },
                ]);
            }
        } catch (error) {
            console.log(error);
        }

        const printAdmissionsWhithoutReciept = (option) => {
            switch (option) {
                case 1:
                    if (!!admissionsWithoutRecipts) {
                        if (!!admissionsWithoutRecipts.admisionesSinRecibo.length) {
                            return {
                                text: "Admisiones PARTICULARES sin recibo de caja",
                                style: "tableheader",
                            }
                        } else {
                            return {
                                text: "No se encontró ninguna admisión de regimén PARTICULAR sin recibo de caja con los filtros seleccionados",
                                style: "textStyle",
                            }
                        }
                    } else {
                        return {
                            text: "No se encontró ninguna admisión de regimén PARTICULAR sin recibo de caja con los filtros seleccionados",
                            style: "textStyle",
                        };
                    }
                    break;
                case 2:
                    try {
                        if (!!admissionsWithoutRecipts) {
                            if (!!admissionsWithoutRecipts.admisionesSinRecibo.length) {
                                return {
                                    margin: [0, 5, 0, 5],
                                    layout: "headerLineOnly",
                                    table: {
                                        headerRows: 1,
                                        widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
                                        body: tableAdmissionsWithoutReceipt
                                    },
                                }
                            } else {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    break;

                default:
                    break;
            }
        }

        const styles = await this.getStyles();
        const documentDefinition = {
            pageSize: "LEGAL",
            pageOrientation: 'landscape',
            styles: styles,
            content: [
                {
                    columns: [
                        {
                            width: 315,
                            columns: [
                                {
                                    image: await this.getBase64ImageFromURL(process.env.REACT_APP_PUBLIC_URL + "clinica/" + clinica.id_clinica + "/logo/" + sessionStorage.getItem('token')),
                                    fit: [180, 90],
                                },
                            ],
                        },
                        {
                            width: 315,
                            fontSize: 10,
                            text: [
                                {
                                    text: clinica.nombre + "\n" +
                                        "NIT:" + clinica.nit + "\n" +
                                        clinica.direccion.direccion + "\n"
                                        + clinica.telefono1 + "\n" +
                                        clinica.email
                                },
                            ],
                            alignment: "center"
                        },
                    ],
                },
                { text: 'Reporte Cierre de Recibos de Caja | ' + 'Fecha Inicio: ' + moment(starterDate).format('DD/MM/YYYY') + ' Fecha Final: ' + moment(finalDate).format('DD/MM/YYYY'), style: 'tableheader' },
                {
                    // auto-sized columns have their widths based on their content                                       
                    margin: [0, 0, 0, 10],
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'/* ,'auto' */],
                        body: this.closuresCashBodyAccountant(data.recibos_caja)
                    },
                },
                printAdmissionsWhithoutReciept(1),
                printAdmissionsWhithoutReciept(2),
                {
                    // auto-sized columns have their widths based on their content    
                    unbreakable: true,
                    margin: [0, 20, 0, 10],
                    layout: 'headerLineOnly',
                    table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: this.totalClosureCash(data)
                    },
                },
                {
                    // auto-sized columns have their widths based on their content  
                    unbreakable: true,
                    margin: [0, 20, 0, 10],
                    layout: 'headerLineOnly',
                    table: {
                        headerRows: 1,
                        widths: ['*', '*'],
                        body: consolidados(data.recibos_consolidados)
                    },
                }
            ],
            footer: function (currentPage, pageCount) {
                return {
                    table: {
                        widths: ['*', '*', '*'],
                        body: [
                            [{
                                text: "Página " + currentPage.toString() + ' de ' + pageCount, style: 'head'
                            },
                            {
                                text: 'Usuario quien imprime: ' + currentUser.nombre, style: 'head'
                            },
                            {
                                text: 'Fecha Impresión: ' + moment(new Date()).format('LLLL'), style: 'head'
                            }],
                        ]
                    },
                    layout: 'noBorders',
                    margin: [20, 0, 0, 5],
                };
            }
        };

        pdfMake.createPdf(documentDefinition).open();
    }

    async getStyles() {
        return {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                margin: [
                    10,//Izquierda
                    20,//Arriba
                    0,//Derecha
                    0//Abajo
                ],
                fontSize: 12,
                bold: true,
            },
            textStyle: {
                fontSize: 9,
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left'
            },
            foter: {
                alignment: 'center',
                fontSize: 6,
            },
            medicStyle: {
                margin: [0, 80, 0, 0],
                fontSize: 10,
                alignment: 'left',
            },
            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },
            textStylePac: {
                fontSize: 10,
                font: 'OpenSans',
                bold: true
            },
            tableheader: {
                fontSize: 11,
                bold: true,
                font: 'OpenSans',
                margin: [0, 20]
            },
            tableTexStyle: {
                fontSize: 8,
                alignment: 'left',
                font: 'OpenSans'
            },
        }
    }

    async getBase64ImageFromURL(url) {
        return new Promise((resolve, reject) => {
            var img = new Image();
            img.setAttribute("crossOrigin", "anonymous");

            img.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;

                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);

                var dataURL = canvas.toDataURL("image/png");

                resolve(dataURL);
            };

            img.onerror = error => {
                reject(error);
            };

            img.src = url;
        });
    }

    showInLetterReceiptsState = (state_receipt, canceledReceipt) => {
        let receipts_state = '';
        if (state_receipt === 1 && canceledReceipt !== true) {
            receipts_state = 'ACTIVO'
        } else if (state_receipt === 2 && canceledReceipt !== true) {
            receipts_state = 'FACTURADO'
        } else {
            receipts_state = 'ANULADO'
        }
        return receipts_state;
    }

    shortendThirdsName(nameService) {
        let numChar = nameService.length;
        let newName = numChar > 18 ? nameService.substring(0, 18) : nameService
        return newName;
    };

    closuresCashBodyAccountant(recibos_caja) {
        let bodyClosure = [];
        let newReciptsWithoutTotalZero = recibos_caja.filter(receipt => parseInt(receipt.total) !== 0);

        bodyClosure.push(
            [
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                { text: '' },
                /* { text: '' }, */
            ]
        );


        bodyClosure.push(
            [
                { text: 'No Recibo', bold: true, style: 'textStyle' },
                { text: 'Fecha Facturación', bold: true, style: 'textStyle' },
                { text: 'Admisión', bold: true, style: 'textStyle' },
                { text: 'Factura', bold: true, style: 'textStyle' },
                { text: 'Num. Documento', bold: true, style: 'textStyle' },
                { text: 'Nombre Paciente', bold: true, style: 'textStyle' },
                /* { text: 'Subtotal', bold: true, style: 'textStyle' }, */
                { text: 'Total', bold: true, style: 'textStyle' },
                { text: 'Medio Pago', bold: true, style: 'textStyle' },
                /* { text: 'Total', bold: true, style: 'textStyle' }, */
                { text: 'Cliente', bold: true, style: 'textStyle' },
                { text: 'Usuario', bold: true, style: 'textStyle' },
                { text: 'Estado', bold: true, style: 'textStyle' },
            ]
        );

        for (var i = 0; i < newReciptsWithoutTotalZero.length; i++) {
            let num_recibo = newReciptsWithoutTotalZero[i].num_recibo != "" && newReciptsWithoutTotalZero[i].num_recibo != null ? newReciptsWithoutTotalZero[i].num_recibo : "N/a";
            let sumSubtotal = parseInt(newReciptsWithoutTotalZero[i].valor_tercero) + parseInt(newReciptsWithoutTotalZero[i].total);
            let cant_total = parseInt(newReciptsWithoutTotalZero[i].total);
            let valor_tercero = parseInt(newReciptsWithoutTotalZero[i].valor_tercero);
            let medio_pago = newReciptsWithoutTotalZero[i].medio_pago?.medio[0].medio;
            bodyClosure.push(
                [
                    { text: num_recibo, style: 'textStyle' },
                    { text: newReciptsWithoutTotalZero[i].fecha_emision != null && newReciptsWithoutTotalZero[i].fecha_emision != undefined ? moment(newReciptsWithoutTotalZero[i].fecha_emision).format("DD/MM/YYYY") : "", style: 'textStyle' },
                    { text: newReciptsWithoutTotalZero[i].id_admision, style: 'textStyle' },
                    { text: newReciptsWithoutTotalZero[i].num_fac_ter, style: 'textStyle' },
                    { text: newReciptsWithoutTotalZero[i].tipo_documento_paciente + "-" + newReciptsWithoutTotalZero[i].num_documento_paciente, style: 'textStyle' },
                    { text: newReciptsWithoutTotalZero[i].nombre_paciente, style: 'textStyle' },
                    /* { text: '$' + formatNumber(sumSubtotal), style: 'textStyle' }, */
                    { text: '$' + formatNumber(cant_total), style: 'textStyle' },
                    { text: medio_pago, style: 'textStyle' },
                    /* { text: '$' + formatNumber(valor_tercero), style: 'textStyle' }, */
                    { text: this.shortendThirdsName(newReciptsWithoutTotalZero[i].cliente), style: 'textStyle' },
                    { text: newReciptsWithoutTotalZero[i].cuenta_usuario, style: 'textStyle' },
                    { text: this.showInLetterReceiptsState(newReciptsWithoutTotalZero[i].estado, newReciptsWithoutTotalZero[i].recibo_cancelado), style: 'textStyle' },
                ]
            );
        }

        return bodyClosure;
    }

    totalClosureCash(data) {
        let bodyClosure = [];
        bodyClosure.push([
            { text: 'Totales', style: 'tableheader' },
            '',
        ]);

        /* bodyClosure.push(
            [
                { text: 'Subtotal', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(parseInt(data.total_recibos) + parseInt(data.copago)), bold: true, style: 'textStyle' },
            ]
        ); */

        bodyClosure.push(
            [
                { text: 'Pagos Tarjetas', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.total_tarjetas), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Cheques', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.total_cheques), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Efectivo', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.total_efectivo), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Otros', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.total_otros), bold: true, style: 'textStyle' },
            ]
        );

        bodyClosure.push(
            [
                { text: 'Pagos Recibidos', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.copago), bold: true, style: 'textStyle' },
            ]
        );


        bodyClosure.push(
            [
                { text: 'Total Anulado', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.total_anulado), bold: true, style: 'textStyle' },
            ]
        );

        /* bodyClosure.push(
            [
                { text: 'Total Facturado', bold: true, style: 'textStyle' },
                { text: '$' + formatNumber(data.total_recibos), bold: true, style: 'textStyle' },
            ]
        ); */


        return bodyClosure;
    }


}


export default new ClosuresOfCashReceiptsPDFAccountant();